export default __webpack_public_path__ + "static/media/btn_close_red.e119242b.svg";